<div *ngIf="isAuthProcessing || isBouncing" class="loading-overlay">
  <div class="ups-spinner"></div>
</div>

<div class="auth-body" *ngIf="!isAuthProcessing && !isBouncing">

   <!-- 🟢 NEW: FIXED MAINTENANCE BANNER AT ABSOLUTE TOP -->
<div *ngIf="currentMaintenanceMessage" class="alert alert-warning text-center" role="alert" style="position: fixed; top: 0; left: 0; width: 100%; z-index: 9999; background-color: #ffc107; color: #000; padding: 15px; font-weight: bold; border-radius: 0; margin: 0;">
  {{ currentMaintenanceMessage }}
</div>
    
    <div *ngIf="showDeletedError" class="floating-error-toast" [ngClass]="{'banner-active': currentMaintenanceMessage}" >
        <div class="toast-content">
            We couldn't find an active UPS Rewards account for this user. Please contact support at <a href="mailto:UPSRewards@ups.com">UPSRewards&#64;ups.com</a>.
        </div>
        <button class="toast-close" aria-label="Close" (click)="closeError()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="card-container">
        <div class="card-inner">
            <img src="../../../assets/icons/UPS_LOGO.svg" alt="UPS Logo" class="logo">
            
            <h1 class="headline">Welcome to UPS Rewards!</h1>
            <div class="yellow-line"></div>

            <p>Ship with UPS and earn reward points</p>

            <p>
                <button class="btn-continue" (click)="onLogin()" >
                    <span>Continue <span class="btn-arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
                            <path d="M6.81434 5.92748L1.68093 10.8229C1.43335 11.059 1.03196 11.059 0.784406 10.8229L0.185678 10.2519C-0.0614783 10.0162 -0.0619537 9.63425 0.184622 9.39799L4.25294 5.49999L0.184622 1.60201C-0.0619537 1.36575 -0.0614783 0.983752 0.185678 0.748052L0.784406 0.177077C1.03198 -0.0590258 1.43337 -0.0590258 1.68093 0.177077L6.81431 5.07252C7.06189 5.3086 7.06189 5.69138 6.81434 5.92748Z" fill="#121212"/>
                        </svg>
                    </span></span>
                </button>
            </p>
         </div>
    </div>
</div>